import React from "react";
import "../styles/general.scss";
import Spritesheet from 'react-responsive-spritesheet';
import PropTypes from 'prop-types';
import {Button} from "@material-ui/core";
import PopUp from "../components/PopUp";
import {absorbEvent} from "../utilities/Utilities";
import PanaromaBackground from "../components/PanaromaBackground";

class GamePage extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            runDistance: 0,
            isRunning: false,
            forward: true,
            speedOffset: 0,
            showLocationDescription: true,
            currentPopUp: -2,
            characterOffset: 0,
            showNavigation: true,
            gameStarted: false,
            popUpDisplay: false
        };

        this.extraPercentage = 0;
        this.fps = 30;
        this.imageWidth = 12000;
        this.imageHeight = 500;
        this.aspectRatio = this.imageWidth / this.imageHeight;
        this.inverseAspectRatio = this.imageHeight / this.imageWidth;
        this.detectionRange = 5;
        this.startCharacterOffsetRange = 10;
        this.verticalFloatSpeed = 10;
        this.corePopUp = React.createRef();
        this.forwardButton = React.createRef();
        this.backwardButton = React.createRef();
        this.speedSlider = React.createRef();
        this.checkLocationNow = true;
        this.actualPosition = 0;
        this.maxPosition = 0;
        this.speed = 10;

        this.lastLocationDescriptionUpdate = 0;

        this.randomNumbers = [];

        this.locationShown = [];

        this.runForward = this
            .runForward
            .bind(this);

        this.runBackward = this
            .runBackward
            .bind(this);

        this.stopRunning = this
            .stopRunning
            .bind(this);

        this.setActualPosition = this
            .setActualPosition
            .bind(this);

        this.locationDescriptionTrigger = this
            .locationDescriptionTrigger
            .bind(this);

        this.getImagePosition = this
            .getImagePosition
            .bind(this);

        this.getTranslateX = this
            .getTranslateX
            .bind(this);

        this.getTranslateY = this
            .getTranslateY
            .bind(this);

        this.showPopUp = this
            .showPopUp
            .bind(this);

        this.closePopUp = this
            .closePopUp
            .bind(this);

        this.getCharacterOffset = this
            .getCharacterOffset
            .bind(this);

        this.disableHaptic = this
            .disableHaptic
            .bind(this);

        this.startGame = this
            .startGame
            .bind(this);

        this.speedChange = this
            .speedChange
            .bind(this);

        this.shouldBlur = this
            .shouldBlur
            .bind(this);
    }

    componentDidMount()
    {
        this.fps = this.props.performanceMode ? 30 : 60;
        this
            .props
            .controlMusicIconFunc(false);

        document.addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });

        document.oncontextmenu = function (e) {
            e.preventDefault();
        };

        this
            .props
            .backgroundFloatImageLists
            .forEach(element => {
                this
                    .randomNumbers
                    .push(Math.random());
            });

        this
            .props
            .locationDescriptionImages
            .forEach(eachImage => {
                this
                    .locationShown
                    .push(false);
            });

        const extraWidth = (((document.documentElement.clientWidth / document.documentElement.clientHeight) - 1) * this.imageHeight) / 2;

        this.extraPercentage = (extraWidth / this.imageWidth) * 100 + (this.imageHeight / this.imageWidth * 100 / 2);
        this.maxPosition = -(100 - (this.extraPercentage * 2));
        this.setActualPosition(0);
        this.locationDescriptionTrigger();
        this.setState({});

        this.disableHaptic();
        this.speedSlider.current.value = this.state.speed;

        // this.setState({runDistance: -85})
    }

    componentWillUnmount()
    {
        if (this.checkLocationTimer !== null && this.checkLocationTimer !== undefined) {
            clearInterval(this.checkLocationTimer);
        }
    }

    disableHaptic()
    {
        this
            .forwardButton
            .current
            .addEventListener("touchend", (event) => {
                this.stopRunning();
                absorbEvent(event);
            });

        this
            .forwardButton
            .current
            .addEventListener("touchstart", (event) => {
                this.runForward();
                absorbEvent(event);
            });
        this
            .forwardButton
            .current
            .addEventListener("touchmove", absorbEvent);
        this
            .forwardButton
            .current
            .addEventListener("touchcancel", absorbEvent);

        this
            .backwardButton
            .current
            .addEventListener("touchend", (event) => {
                this.stopRunning();
                absorbEvent(event);
            });

        this
            .backwardButton
            .current
            .addEventListener("touchstart", (event) => {
                this.runBackward();
                absorbEvent(event);
            });
        this
            .backwardButton
            .current
            .addEventListener("touchmove", absorbEvent);
        this
            .backwardButton
            .current
            .addEventListener("touchcancel", absorbEvent);
    }

    getCharacterOffset()
    {
        // const offset = Math.abs(this.maxPosition - this.extraPercentage) -
        // Math.abs(this.actualPosition); if (offset < this.startCharacterOffsetRange) {
        //     return (document.documentElement.clientWidth / 4) -
        // (document.documentElement.clientWidth / 4 * (offset /
        // this.startCharacterOffsetRange)); }
        return 0;
    }

    setActualPosition(devicePosition)
    {
        this.actualPosition = Math.abs(devicePosition - this.extraPercentage + (this.imageHeight / this.imageWidth));
    }

    locationDescriptionTrigger()
    {
        if (this.checkLocationNow) {
            this
                .locationShown
                .forEach((eachLocation, index) => {
                    if (!this.locationShown[index]) {
                        if (this.actualPosition > this.props.locationMarker[index] - this.detectionRange) {
                            this.locationShown[index] = true;
                        }
                    }
                });
        }

        this.checkLocationNow = !this.checkLocationNow;
    }

    getImagePosition(percentage)
    {

        var position = ((percentage - this.actualPosition) * (this.imageWidth - document.documentElement.clientWidth) / 100);
        return position;
    }

    runForward()
    {
        this
            .props
            .logFunc("Running forward");
        this.setState({isRunning: true, forward: true});

        if (this.backwardTimer != null) {
            clearInterval(this.backwardTimer);
        }

        this.forwardTimer = setInterval(() => {
            const devicePosition = Math.max(this.maxPosition, (this.state.runDistance - ((this.speed + this.state.speedOffset + 1) / this.imageWidth * 100) * 60 / this.fps));
            this.setActualPosition(devicePosition);
            this.locationDescriptionTrigger();
            this.setState({
                runDistance: devicePosition,
                characterOffset: this.getCharacterOffset(),
                isRunning: true
            });
            if (!this.state.forward) {
                clearInterval(this.forwardTimer);
            }

        }, 1000 / this.fps);

        if (this.spritesheetInstance !== null && this.spritesheetInstance !== undefined) {
            this
                .spritesheetInstance
                .play();
        }
    }

    runBackward()
    {
        this
            .props
            .logFunc("Running back");
        this.setState({isRunning: true, forward: false});
        if (this.forwardTimer != null) {
            clearInterval(this.forwardTimer);
        }

        this.backwardTimer = setInterval(() => {
            const devicePosition = Math.min(0, (this.state.runDistance + ((this.speed + this.state.speedOffset + 1) / this.imageWidth * 100) * 60 / this.fps));
            this.setActualPosition(devicePosition);
            this.locationDescriptionTrigger();
            this.setState({
                runDistance: devicePosition,
                characterOffset: this.getCharacterOffset(),
                isRunning: true
            });
            if (this.state.forward) {
                clearInterval(this.backwardTimer);
            }
        }, 1000 / this.fps);

        if (this.spritesheetInstance !== null && this.spritesheetInstance !== undefined) {
            this
                .spritesheetInstance
                .play();
        }
    }

    stopRunning()
    {
        this
            .props
            .logFunc("Stop running");
        if (this.forwardTimer != null) {
            clearInterval(this.forwardTimer);
        }
        if (this.backwardTimer != null) {
            clearInterval(this.backwardTimer);
        }
        if (this.spritesheetInstance !== null && this.spritesheetInstance !== undefined) {
            this
                .spritesheetInstance
                .pause();
        }

        this.setState({isRunning: false});
    }

    getTranslateX(positionX)
    {
        return -((this.actualPosition - positionX) * this.imageWidth / 100 / (this.imageHeight / document.documentElement.clientHeight));
    }

    getTranslateY(positionY)
    {
        return -((this.actualPosition - positionY) * this.imageWidth / 100 / (this.imageHeight / document.documentElement.clientHeight));
    }

    showPopUp(index)
    {
        this
            .props
            .controlMusicIconFunc(false);
        this.setState({currentPopUp: index, showNavigation: false, popUpDisplay: true});
        this
            .corePopUp
            .current
            .enable();
    }

    closePopUp()
    {
        this.setState({showNavigation: true, popUpDisplay: false});
        this
            .props
            .controlMusicIconFunc(true);
    }

    speedChange(speed)
    {
        this.speed = parseInt(speed.target.value);
        this.setState({});
    }

    startGame()
    {
        window.sendTracking("page", "pageview", "game");
        
        this
            .props
            .controlMusicIconFunc(true);
        this.setState({gameStarted: true});
    }

    shouldBlur()
    {
        return ((this.actualPosition - this.extraPercentage) > 1 && this.state.runDistance > this.maxPosition) && this.state.isRunning;
    }

    render()
    {
        return (
            <React.Fragment>
                <div
                    className={this.state.gameStarted
                    ? "blur-out"
                    : ""}
                    style={{
                    overflow: "hidden",
                    filter: this.state.gameStarted
                        ? "brightness(100%)"
                        : "blur(0.125rem)",
                    height: "100vh",
                    width: "100vw",
                    position: "absolute"
                }}>
                    <div
                        style={{
                        zIndex: 0,
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        overflow: "hidden"
                    }}><img
                        src={this.props.backgroundImage}
                        alt="background gradient"
                        style={{
                height: "100vh",
                width: "100vw"
            }}/></div>
                    <div
                        style={{
                        zIndex: 1,
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        overflow: "hidden"
                    }}>
                        <div
                            className="horizontal-float"
                            style={{
                            width: "100%",
                            height: "100vh"
                        }}>
                            {this.props.performanceMode
                                ? null
                                : <PanaromaBackground
                                    runDistance={this.state.runDistance}
                                    backgroundImage={this.props.backgroundCloudImage}
                                    style={{
                                    width: "100%",
                                    height: "100vh"
                                }}/>}
                            {/* <PanaromaAnimator
                            runDistance={this.state.runDistance}
                            backgroundImages={this.props.backgroundCloudImagesList}
                            style={{
                            width: "100%",
                            height: "100vh"
                        }}/> */}
                        </div>
                    </div>
                    {this.props.performanceMode
                        ? null
                        : this
                            .props
                            .backgroundFloatImageLists
                            .map((eachImage, index) => {
                                const position = this.getImagePosition(eachImage.x);
                                return position < document.documentElement.clientWidth * 2 && position > -document.documentElement.clientWidth
                                    ? (
                                        <div
                                            className="vertical-float"
                                            id={`background_float_element_` + index}
                                            key={`background_float_element_` + index}
                                            style={{
                                            zIndex: 5,
                                            width: "100%",
                                            height: "100vh",
                                            position: "absolute",
                                            overflow: "hidden",
                                            display: "flex",
                                            justifyContent: "center",
                                            animationDuration: (this.randomNumbers[index] * this.verticalFloatSpeed + this.verticalFloatSpeed) + "s",
                                            WebkitAnimationDuration: (this.randomNumbers[index] * this.verticalFloatSpeed + this.verticalFloatSpeed) + "s",
                                            animationDirection: index % 2 === 0
                                                ? "normal"
                                                : "alternate",
                                            WebkitAnimationDirection: index % 2 === 0
                                                ? "normal"
                                                : "alternate"
                                        }}>
                                            <img
                                                src={`data:image/png;base64, ${eachImage.image}`}
                                                alt={"Floating " + index}
                                                style={{
                                                height: "100vh",
                                                transform: `translateX(${this.getTranslateX(eachImage.x)}px)`
                                            }}/>
                                        </div>
                                    )
                                    : null;
                            })}
                    <div
                        style={{
                        zIndex: 2,
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        overflow: "hidden"
                    }}>
                        <PanaromaBackground
                            backgroundImage={this.props.performanceMode
                            ? this.props.midgroundFullImage
                            : this.props.midgroundImage}
                            runDistance={this.state.runDistance}
                            scaleX={2}
                            style={{
                            width: "100%",
                            height: "100vh"
                        }}/> {/* <PanaromaAnimator
                        backgroundImages={this.props.midgroundImagesList}
                        runDistance={this.state.runDistance}
                        style={{
                        width: "100%",
                        height: "100vh"
                    }}/> */}
                    </div>
                    {this.props.performanceMode
                        ? this
                            .props
                            .locationDescriptionImages
                            .map((eachImage, index) => {
                                const position = this.getImagePosition(this.props.locationMarker[index]);
                                return position < document.documentElement.clientWidth * 2 && position > -document.documentElement.clientWidth
                                    ? (
                                        <div
                                            key={this.locationShown[index]
                                            ? "show_description_" + index
                                            : "hide_description_" + index}
                                            className={this.locationShown[index]
                                            ? "location-description"
                                            : ""}
                                            style={{
                                            zIndex: 3,
                                            width: "100%",
                                            height: "100vh",
                                            position: "absolute",
                                            overflow: "hidden",
                                            display: this.locationShown[index]
                                                ? "flex"
                                                : "none",
                                            justifyContent: "center"
                                        }}>
                                            <img
                                                src={eachImage}
                                                alt={"Location " + index}
                                                style={{
                                                height: "100vh",
                                                transform: `translateX(${this.getTranslateX(this.props.locationMarker[index]) * 1.1}px)`
                                            }}/>
                                        </div>
                                    )
                                    : null;
                            })
                        : this
                            .props
                            .locationDescriptionImagesB64
                            .map((eachImage, index) => {
                                const position = this.getImagePosition(this.props.locationMarker[index]);
                                return position < document.documentElement.clientWidth * 2 && position > -document.documentElement.clientWidth
                                    ? (
                                        <div
                                            key={this.locationShown[index]
                                            ? "show_description_" + index
                                            : "hide_description_" + index}
                                            className={this.locationShown[index]
                                            ? "location-description"
                                            : ""}
                                            style={{
                                            zIndex: 3,
                                            width: "100%",
                                            height: "100vh",
                                            position: "absolute",
                                            overflow: "hidden",
                                            display: this.locationShown[index]
                                                ? "flex"
                                                : "none",
                                            justifyContent: "center"
                                        }}>
                                            <img
                                                src={`data:image/png;base64, ${eachImage}`}
                                                alt={"Location " + index}
                                                style={{
                                                height: "100vh",
                                                transform: `translateX(${this.getTranslateX(this.props.locationMarker[index]) * 1.1}px)`
                                            }}/>
                                        </div>
                                    )
                                    : null;
                            })}
                    <div
                        style={{
                        zIndex: 5,
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        display: "flex",
                        justifyContent: "center",
                        overflow: "hidden"
                    }}>
                        <div
                            style={{
                            height: "22.5vh",
                            width: "22.5vh",
                            top: "57.5vh",
                            position: "absolute",
                            zIndex: 7,
                            transform: `translateX(-${this.state.characterOffset}px)`
                        }}><Spritesheet
                            key={`${this.speed}_${this.state.speedOffset}`}
                            style={{
                visibility: this.state.isRunning
                    ? "visible"
                    : "hidden",
                transform: `scaleX(${this.state.forward
                    ? 1
                    : -1})`
            }}
                            image={this.props.animation}
                            widthFrame={125}
                            heightFrame={125}
                            steps={16}
                            fps={Math.max(8, 16 * (this.speed + this.state.speedOffset + 1) / 10)}
                            autoplay={false}
                            getInstance={spritesheet => {
                this.spritesheetInstance = spritesheet;
            }}
                            loop={true}/>
                        </div>
                        <div
                            style={{
                            height: "22.5vh",
                            width: "22.5vh",
                            top: "57.5vh",
                            position: "absolute",
                            zIndex: 5,
                            transform: `translateX(-${this.state.characterOffset}px)`
                        }}><img
                            src={`data:image/png;base64, ${this.props.animationRest}`}
                            style={{
                width: "100%",
                height: "100%",
                visibility: !this.state.isRunning
                    ? "visible"
                    : "hidden",
                transform: `scaleX(${this.state.forward
                    ? 1
                    : -1})`
            }}
                            alt="Rest mode"/></div>
                    </div>
                    <div
                        style={{
                        zIndex: 10,
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        overflow: "hidden"
                    }}>
                        <PanaromaBackground
                            backgroundImage={this.props.performanceMode
                            ? this.props.foregroundFullImage
                            : this.props.foregroundImage}
                            runDistance={this.state.runDistance}
                            scaleX={2}
                            style={{
                            width: "100%",
                            height: "100vh"
                        }}/> {/* <PanaromaAnimator
                        backgroundImages={this.props.foregroundImagesList}
                        runDistance={this.state.runDistance}
                        style={{
                        width: "100%",
                        height: "100vh"
                    }}/> */}
                    </div>
                    {this.getImagePosition(98.5) < document.documentElement.clientWidth * 2
                        ? <div
                                style={{
                                zIndex: 60,
                                position: "absolute",
                                transform: `translateX(${this.getTranslateX(98.5)}px)`
                            }}>
                                <div
                                    style={{
                                    width: "100vw",
                                    height: "100vh",
                                    display: "flex",
                                    justifyContent: "center"
                                }}><img
                                    src={`data:image/png;base64, ${this.props.contentImage}`}
                                    alt="Content"
                                    style={{
                                height: "100vh"
                            }}/></div>
                            </div >
                        : null}
                    {this.getImagePosition(98.5) < document.documentElement.clientWidth * 2
                        ? <div
                                style={{
                                zIndex: 60,
                                position: "absolute",
                                transform: `translateX(${this.getTranslateX(98.5)}px)`,
                                bottom: 0
                            }}>
                                <div
                                    style={{
                                    width: "100vw",
                                    height: "47.5vh",
                                    display: "flex",
                                    justifyContent: "center"
                                }}><img
                                    id="poster"
                                    onTouchStart={this.props.enterPosterPageFunc}
                                    src={`data:image/png;base64, ${this.props.buttonImage}`}
                                    alt="Content"
                                    style={{
                                height: "10vh"
                            }}/></div>
                            </div >
                        : null}
                    <div>
                        <Button
                            ref={this.forwardButton}
                            id={this.state.showNavigation
                            ? "navigator"
                            : ""}
                            className={this.state.showNavigation && this.state.gameStarted && this.state.runDistance - 0.25 > this.maxPosition
                            ? "fade-in"
                            : "fade-out"}
                            disableRipple={true}
                            disableFocusRipple={true}
                            disableTouchRipple={true}
                            disableElevation={true}
                            style={{
                            backgroundColor: "transparent",
                            zIndex: this.state.popUpDisplay
                                ? 50
                                : 85,
                            visibility: this.state.gameStarted
                                ? "visible"
                                : "hidden",
                            position: "fixed",
                            fontSize: 24,
                            fontWeight: 900,
                            bottom: "5vh",
                            right: "15vh",
                            borderRadius: "10em",
                            animationDuration: "0.5s",
                            WebkitAnimationDuration: "0.5s",
                            pointerEvents: this.state.runDistance - 0.25 > this.maxPosition ? "auto" : "none"
                        }}><img
                            style={{
                width: "20vh",
                height: "20vh"
            }}
                            src={this.state.isRunning && this.state.forward
                ? this.props.forwardButtonPressedImage
                : this.props.forwardButtonReleasedImage}
                            alt="Move forward"/></Button>
                        <Button
                            ref={this.backwardButton}
                            id={this.state.showNavigation
                            ? "navigator"
                            : ""}
                            className={this.state.showNavigation && (this.actualPosition - this.extraPercentage) > 1
                            ? "fade-in"
                            : "fade-out"}
                            disableRipple={true}
                            disableFocusRipple={true}
                            disableTouchRipple={true}
                            disableElevation={true}
                            style={{
                            backgroundColor: "transparent",
                            zIndex: this.state.currentPopUp > -1
                                ? 50
                                : 85,
                            position: "fixed",
                            fontSize: 24,
                            fontWeight: 900,
                            bottom: "5vh",
                            left: "15vh",
                            borderRadius: "10em",
                            visibility: "visible",
                            animationDuration: "0.5s",
                            WebkitAnimationDuration: "0.5s",
                            pointerEvents: (this.actualPosition - this.extraPercentage) > 1 ? "auto" : "none"
                        }}><img
                            style={{
                width: "20vh",
                height: "20vh"
            }}
                            src={this.state.isRunning && !this.state.forward
                ? this.props.backwardButtonPressedImage
                : this.props.backwardButtonReleasedImage}
                            alt="Move backward"/></Button>
                    </div>

                    <div
                        style={{
                        display: "flex",
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        justifyContent: "center",
                        overflow: "hidden"
                    }}>
                        {this
                            .props
                            .popUpMarker
                            .map((eachPopUpPoint, index) => {
                                const position = this.getImagePosition(eachPopUpPoint.x);
                                return position < document.documentElement.clientWidth * 2 && position > -document.documentElement.clientWidth
                                    ? (
                                        <Button
                                            disableRipple={true}
                                            disableFocusRipple={true}
                                            disableTouchRipple={true}
                                            disableElevation={true}
                                            id={"pop_up_button_" + index}
                                            key={"pop_up_button_" + index}
                                            onTouchStart={() => this.showPopUp(index)}
                                            style={{
                                            zIndex: 45,
                                            fontSize: 24,
                                            fontWeight: 900,
                                            position: "absolute",
                                            transform: `translate(${this.getTranslateX(eachPopUpPoint.x)}px, ${eachPopUpPoint.y}vh)`,
                                            overflow: "hidden"
                                        }}>
                                            <img
                                                className="light-bulb"
                                                src={`data:image/png;base64, ${this.props.lightBulbButtonImage}`}
                                                alt="Light bulb button"
                                                style={{
                                                height: "20vh",
                                                borderRadius: "16em"
                                            }}/>
                                        </Button>
                                    )
                                    : null;
                            })}
                    </div>
                    <PopUp
                        performanceMode={this.props.performanceMode}
                        ref={this.corePopUp}
                        leftButtonImage={`data:image/png;base64, ${this.props.popUpLeftButtonImage}`}
                        rightButtonImage={`data:image/png;base64, ${this.props.popUpRightButtonImage}`}
                        closeButtonImage={`data:image/png;base64, ${this.props.popUpCloseButtonImage}`}
                        closePopUpFunc={this.closePopUp}
                        popUpID={this.state.currentPopUp}
                        darkBG={this.props.darkBG}
                        images={this.props.popUpMarker[Math.max(0, this.state.currentPopUp)].images}
                        style={{
                        display: "flex",
                        width: "100%",
                        height: "100vh",
                        position: "absolute",
                        justifyContent: "center",
                        overflow: "hidden"
                    }}/>
                </div>
                <div
                    className={this.state.showNavigation && this.state.gameStarted
                    ? "fade-in"
                    : "fade-out"}
                    style={{
                    zIndex: 200,
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    position: "absolute",
                    justifyContent: "flex-start",
                    alignContent: "center",
                    overflow: "hidden",
                    pointerEvents: "none",
                    visibility: this.state.gameStarted
                        ? "visible"
                        : "hidden",
                    animationDuration: "0.5s",
                    WebkitAnimationDuration: "0.5s"
                }}>
                    <form
                        className="range"
                        style={{
                        alignSelf: "center",
                        width: "35vh"
                    }}>
                        <div className="form-group" style={{}}>
                            <input
                                ref={this.speedSlider}
                                className="speed-slider"
                                type="range"
                                step="1"
                                min={0}
                                max={20}
                                style={{
                                pointerEvents: "visible"
                            }}
                                onChange={this.speedChange}/>
                        </div>
                    </form>
                </div>
                <div
                    className={this.state.gameStarted
                    ? "fade-out"
                    : ""}
                    style={{
                    zIndex: 250,
                    display: "flex",
                    width: "100%",
                    height: "100vh",
                    position: "absolute",
                    justifyContent: "center",
                    alignContent: "center",
                    overflow: "hidden",
                    // backgroundColor: "#000000C0",
                    backgroundImage: `url("data:image/png;base64, ${this.props.darkBG}")`,
                    pointerEvents: "none"
                }}>
                    <img
                        src={`data:image/png;base64, ${this.props.gameplayTipsContent}`}
                        alt="Gameplay tips"
                        style={{
                        maxWidth: "90vw",
                        maxHeight: "90vh",
                        alignSelf: "center"
                    }}/>
                    <img
                        id="poster"
                        onClick={this.startGame}
                        src={`data:image/png;base64, ${this.props.startGameButton}`}
                        alt="Gameplay tips"
                        style={{
                        maxWidth: "50vw",
                        maxHeight: "10vh",
                        position: "absolute",
                        marginBottom: "15vh",
                        bottom: 0,
                        pointerEvents: this.state.gameStarted
                            ? "none"
                            : "visible"
                    }}/>
                </div>
            </React.Fragment>
        );
    }
}

GamePage.propTypes = {
    backwardButtonReleasedImage: PropTypes.string,
    backwardButtonPressedImage: PropTypes.string,
    forwardButtonReleasedImage: PropTypes.string,
    forwardButtonPressedImage: PropTypes.string,
    popUpLeftButtonImage: PropTypes.string,
    popUpRightButtonImage: PropTypes.string,
    popUpCloseButtonImage: PropTypes.string,
    locationDescriptionImages: PropTypes.array,
    backgroundFloatImages: PropTypes.array,
    backgroundImage: PropTypes.string,
    backgroundCloudImage: PropTypes.string,
    midgroundImage: PropTypes.string,
    lightBulbButtonImage: PropTypes.string,
    animation: PropTypes.string,
    animationRest: PropTypes.string,
    foregroundImage: PropTypes.string,
    titleImage: PropTypes.string,
    contentImage: PropTypes.string,
    buttonImage: PropTypes.string,
    imageWidth: PropTypes.number,
    speed: PropTypes.number,
    locationMarker: PropTypes.array,
    logFunc: PropTypes.func,
    controlMusicIconFunc: PropTypes.func,
    enterPosterPageFunc: PropTypes.func
};

GamePage.defaultProps = {
    backwardButtonReleasedImage: "",
    backwardButtonPressedImage: "",
    forwardButtonReleasedImage: "",
    forwardButtonPressedImage: "",
    popUpLeftButtonImage: "",
    popUpRightButtonImage: "",
    popUpCloseButtonImage: "",
    locationDescriptionImages: [],
    backgroundFloatImages: [],
    backgroundImage: "",
    backgroundCloudImage: "",
    midgroundImage: "",
    lightBulbButtonImage: "",
    titleImage: "",
    contentImage: "",
    buttonImage: "",
    animation: "",
    animationRest: "",
    foregroundImage: "",
    imageWidth: 0,
    speed: 0,
    locationMarker: [],
    logFunc: function (log) {
        console.log("Logging -> " + log);
    },
    controlMusicIconFunc: function (log) {
        console.log("controlMusicIconFunc");
    },
    enterPosterPageFunc: function (log) {
        console.log("enterPosterPageFunc");
    }
};

export default GamePage;